<template>
  <div class="personal-center">
    <div class="join-img">
      <img src="./images/1.jpg" alt="">
    </div>
    <div class="p">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{ this.$route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class='join-main'>
      <leftBox class="left" :navleft="navleft" :p="ptitle" :navtype="navtype"></leftBox>
      <div class="main-right-talented" v-if="$route.meta.title == '个人信息'">
        <personalinfoRight></personalinfoRight>
      </div>
      <div v-if="$route.meta.title == '订单中心'" class="main-right-talented">
        <orderCenterRight></orderCenterRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '试用商品订单'">
        <tryOrderCenterRight></tryOrderCenterRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '地址管理'">
        <addressManageRight></addressManageRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '发票管理'">
        <invoiceControlRight></invoiceControlRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '修改密码'">
        <changePasswordRight></changePasswordRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '订单详情'">
        <orderDetail></orderDetail>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '试用订单详情'">
        <tryOrderDetail></tryOrderDetail>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '余额日志'">
        <balanceRight></balanceRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '信用日志'">
        <creditRight></creditRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '售后信息'">
        <AfterSalesRight></AfterSalesRight>
      </div>
      <div class="main-right-talented" v-if="$route.meta.title == '取消订单'">
        <cancelOrderPage></cancelOrderPage>
      </div>
    </div>
    <div class="rightfixed">
      <ul :class="searchBarFixed == true ? 'isFixed' :''">
        <rightFixed></rightFixed>
      </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from '../../components/bottom'
import leftBox from "../../components/leftBox"
import rightFixed from "../productCenter/components/rightFixed"
import personalinfoRight from './personalinfo/components/right'
import orderCenterRight from './orderCenter/components/right'
import changePasswordRight from "./changePassword/components/right"
import addressManageRight from "./addressManage/components/right"
import invoiceControlRight from "./InvoiceControl/components/right"
import orderDetail from "./orderCenter/Detail/components/right"
import balanceRight from './balance/components/right'
import creditRight from './credit/components/right'
import tryOrderCenterRight from './tryOrderCenter/components/right'
import tryOrderDetail from './tryOrderCenter/Detail/components/right'
import AfterSalesRight from './afterSaleList/components/right'
import cancelOrderPage from './cancelOrderPage/components/right'

export default {
  data() {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      ptitle: '个人中心',
      navtype: 'three',
      navleft: [
        {
          title: "个人信息",
          url: "/personalCenter/personalinfo"
        },
        {
          title: "订单中心",
          url: '/personalCenter/orderCenter'
        },
        {
          title: "试用订单",
          url: '/personalCenter/tryOrderCenter'
        },
        {
          title: "地址管理",
          url: '/personalCenter/addressManage'
        },
        {
          title: "发票管理",
          url: '/personalCenter/InvoiceControl'
        },
        {
          title: "修改密码",
          url: '/personalCenter/changePassword'
        },
        {
          title: "我的余额",
          url: '/personalCenter/balance'
        },
        {
          title: "信用额度",
          url: '/personalCenter/credit'
        },
        {
          title: "售后信息",
          url: '/personalCenter/afterSaleList'
        },
        {
          title: "取消订单",
          url: '/personalCenter/cancelOrderPage'
        }
      ]
    }
  },
  components: {
    Bottom,
    leftBox,
    rightFixed,
    personalinfoRight,
    orderCenterRight,
    changePasswordRight,
    addressManageRight,
    invoiceControlRight,
    tryOrderCenterRight,
    orderDetail,
    balanceRight,
    tryOrderDetail,
    creditRight,
    AfterSalesRight,
    cancelOrderPage
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var offsetTop = document.querySelector('.rightfixed').offsetTop
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="less" scoped>
.personal-center {
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  position: relative;

  .rightfixed {
    width: 90px;
    height: 230px;
    position: absolute;
    top: 550px;
    right: 10px;

    .isFixed {
      position: fixed;
      bottom: 150px;
      z-index: 999;
    }
  }

  .box-one {
    width: 1510px;
    height: 316px;
    background: #f6f6f6;
    margin: auto;
    background: url("../../images/four.png");
  }

  .p {
    font-size: 14px;
    margin: 20px 0px 20px 300px;;
    color: #666666;
    line-height: 19px;

    /deep/ .el-breadcrumb__inner.is-link {
      color: #666666
    }
  }

  .join-main {
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;;
    display: flex;

    .left {
      margin-left: 130px;
    }

    .main-right-talented {
      width: 876px;
      background: #ffffff;
      margin-top: 44px;;
      margin-bottom: 27px;
      margin-left: 61px;
    }
  }

  .join-img {
    width: 100%;

    img {
      width: 1920px;
      height: 300px;
    }
  }

  .five {
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;

    span {
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>
